<template>
  <section>
    <AboutHero />
  </section>
</template>

<script>
import AboutHero from "@/components/AboutHero.vue";

export default {
  components: {
    AboutHero
  }
};
</script>

<style lang="scss" scoped></style>
